import React from 'react';
import {useNavigate, useParams} from "react-router-dom";
import {useModel23Query, useUpdateModel23} from "../query";
import MDBox from "materialDashboard/components/MDBox";
import {useTranslation} from "react-i18next";
import Model23Form from "../Model23Form";


const Model23Edit = () => {
    const {t} = useTranslation(['models23']);
    const navigate = useNavigate();

    const {model23Id} = useParams();
    const model23Query = useModel23Query(model23Id);
    const updateModel23 = useUpdateModel23(model23Id);

    const handleSubmit = async (data) => {
        await updateModel23.mutateAsync(data);
        await navigate('/models23');
    }

    return <MDBox sx={{mx: 2}}>
        {
            model23Query.isLoading ? "Loading" : <Model23Form title={t('model23Edit.title')}
                                                              model23={model23Query.data}
                                                              onSubmit={handleSubmit}
                                                              model23Id={model23Id}/>
        }
    </MDBox>
}

export default Model23Edit;